<h2 class="">Michigan Public Service Commission</h2>
<div class="col-sm-12 well">
  <p id="ContributionsText">
    Per the Michigan Telecommunications Act, the contributions that were due on
    August 13, 2022 (for the July 2022 reporting month) were the final
    contributions to the ARM. ARM filings for any months after this are no
    longer required. If you need to file an ARM form for a previous month or
    make a correction to an existing ARM filing please contact Amber McGrath at
    <a href=" mailto:McGrathA@michigan.gov">McGrathA@michigan.gov</a>.
  </p>
</div>
